"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TELCO_IDO = void 0;
exports.TELCO_IDO = { INDUSTEL: 374, TELESTAR: 312 };
